<template>
 <div>
	<template v-if="payments === true">
        <div v-show="isDataTableLoading === false">
            <div class="page-top mb-1 mb-3 align-left clearfix">
		    	<h1> Payroll Payments</h1>
		    </div>

		    <!-- <div class="alert alert-danger" role="alert">
		    	<p><b> Notice! </b>&nbsp;Dear Partner, We are experiencing service degradation due to system maintenance activity.
		    		Kindly avoid using CNIC disbursements till further notice.
		    	Inconvenience is regretted.</p>
		    </div> -->

			<!-- New Batch Modal -->
			<div class="modal fade" id="newBatchModal" tabindex="-1" role="dialog" aria-labelledby="newBatchModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-md modal-dialog-centered" role="document">
					<div class="modal-content">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
						<div class="modal-body new-batch-popup">
							<div class="popup-head line-head mt-4 mb-5">
								<h2 class="pb-3"> Select Payment Type </h2>
							</div>
							<div class="new-batch-boxes-holder">
								<div class="row">
									<div class="col">
										<div class="batch-box" :class="{ 'active': tick_active == true}">
											<div class="spin-tick">
												<div class="add-spin"></div>
												<img src="/images/svgs/new-batch-tick.svg" class="tick-check" alt="" />
											</div>
                                            <span @click="proceedToGenerateBatch">
                                                <img src="/images/new-batch-icon1.png" alt="" />
                                                <p> Batch Upload </p>
                                            </span>
										</div>
									</div>
									<div class="col">
										<div class="batch-box" :class="{ 'active': tick_active == true}">
											<div class="spin-tick">
												<div class="add-spin"></div>
												<img src="/images/svgs/new-batch-tick.svg" class="tick-check" alt="" />
											</div>
											<span @click="proceedToAutoGenerate">
												<img src="/images/new-batch-icon2.png" alt="" />
												<p> Auto Generate </p>
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="page-top mb-1 mb-3 clearfix">
				<ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
					<li class="nav-item">
						<a class="nav-link active" id="new-tab" data-toggle="tab" href="#new" role="tab" aria-controls="new" aria-selected="true" @click="reloadList('new')">New ({{new_batch_count}})</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" id="inprocess-tab" data-toggle="tab" href="#inprocess" role="tab" aria-controls="inprocess" aria-selected="false" @click="reloadList('inprocess')">In Process ({{inprocess_batch_count}})</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" id="processed-tab" data-toggle="tab" href="#processed" role="tab" aria-controls="rejected" aria-selected="false" @click="reloadList('processed')">Processed ({{processed_batch_count}})</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" id="disapproved-tab" data-toggle="tab" href="#disapproved" role="tab" aria-controls="disapproved" aria-selected="false" @click="reloadList('disapproved')">Disapproved ({{disapproved_batch_count}})</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" id="error-tab" data-toggle="tab" href="#error" role="tab" aria-controls="error" aria-selected="false" @click="reloadList('error')">Error ({{error_batch_count}})</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" id="archived-tab" data-toggle="tab" href="#archived" role="tab" aria-controls="archived" aria-selected="false" @click="reloadList('archived')">Archived ({{archived_batch_count}})</a>
					</li>
					<li class="nav-item" v-if="create_payroll_batch">
						<a class="nav-link" id="draft-tab" data-toggle="tab" href="#draft" role="tab" aria-controls="draft" aria-selected="false" @click="reloadList('draft')">Draft ({{draft_batch_count}})</a>
					</li>
				</ul>
				<a v-if="create_payroll_batch" href="javascript:void(0)" data-toggle="modal" data-target="#newBatchModal" class="btn btn-primary float-right"> New Batch </a>

			</div>
			<div class="tab-content" id="myTabContent">
				<div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
					<table id="dt-new" class="table" style="width:100%">
						<thead>
							<tr>
								<th>ID</th>
								<th style="width:200px">Title</th>
								<th>Created On</th>
								<th>Type</th>
								<th>Time Period</th>
								<th>Amount</th>
								<th style="width:100px">Status</th>
								<th style="width:100px">Action</th>
							</tr>
						</thead>
					</table>
				</div>
				<div class="tab-pane fade" id="inprocess" role="tabpanel" aria-labelledby="inprocess-tab">
					<table id="dt-inprocess" class="table" style="width:100%">
						<thead>
							<tr>
								<th>ID</th>
								<th style="width:200px">Title</th>
								<th>Created On</th>
								<th>Type</th>
								<th>Time Period</th>
								<th>Amount</th>
								<th style="width:100px" >Status</th>
								<th >Action</th>
							</tr>
						</thead>
					</table>
				</div>
				<div class="tab-pane fade" id="processed" role="tabpanel" aria-labelledby="processed-tab">
					<table id="dt-processed" class="table" style="width:100%">
						<thead>
							<tr>
								<th>ID</th>
								<th style="width:200px">Title</th>
								<th>Created On</th>
								<th>Type</th>
								<th>Time Period</th>
								<th>Amount</th>
								<th style="width:100px">Status</th>
								<th>Action</th>
							</tr>
						</thead>
					</table>
				</div>
				<div class="tab-pane fade" id="disapproved" role="tabpanel" aria-labelledby="disapproved-tab">
					<table id="dt-disapproved" class="table" style="width:100%">
						<thead>
							<tr>
								<th>ID</th>
								<th style="width:200px">Title</th>
								<th>Created On</th>
								<th>Type</th>
								<th>Time Period</th>
								<th>Amount</th>
								<th style="width:100px">Status</th>
								<th>Action</th>
							</tr>
						</thead>
					</table>
				</div>
				<div class="tab-pane fade" id="error" role="tabpanel" aria-labelledby="error-tab">
					<table id="dt-error" class="table" style="width:100%">
						<thead>
							<tr>
								<th style="width:200px">ID</th>
								<th>Title</th>
								<th>Created On</th>
								<th>Type</th>
								<th>Time Period</th>
								<th>Amount</th>
								<th style="width:100px">Status</th>
								<th >Action</th>
							</tr>
						</thead>
					</table>
				</div>
				<div class="tab-pane fade" id="archived" role="tabpanel" aria-labelledby="archived-tab">
					<table id="dt-archived" class="table" style="width:100%">
						<thead>
							<tr>
								<th>ID</th>
								<th style="width:200px">Title</th>
								<th>Created On</th>
								<th>Type</th>
								<th>Time Period</th>
								<th>Amount</th>
								<th style="width:100px">Status</th>
								<th >Action</th>
							</tr>
						</thead>
					</table>
				</div>
				<div class="tab-pane fade" id="draft" role="tabpanel" aria-labelledby="draft-tab">
					<table id="dt-draft" class="table" style="width:100%">
						<thead>
							<tr>
								<th>ID</th>
								<th style="width:200px">Title</th>
								<th>Created On</th>
								<th>Batch Month</th>
								<th>Amount</th>
								<th>State</th>
								<th class="text-center">Action</th>
							</tr>
						</thead>
					</table>
				</div>
			</div>
		</div>
		<preLoader v-show="isDataTableLoading === true"></preLoader>
	</template>
    <template v-else-if="payments === null">
        <preLoader></preLoader>
    </template>
    <template v-else-if="payments === false">
		<notAllowed></notAllowed>
    </template>
 </div>
</template>

<script>
	var gThat = null;
    export default {
        data() {
            return {
                data : null,
                new_batch_count : 0,
                inprocess_batch_count : 0,
                processed_batch_count : 0,
                disapproved_batch_count : 0,
                error_batch_count : 0,
                archived_batch_count : 0,
                draft_batch_count : 0,
				payments : null,
				create_payroll_batch : null,
				tick_active : false,
				currentActiveTab : 'new',
				isDataTableLoading : false,
				dtNew : null,
				dtInprocess : null,
				dtprocessed : null,
				dtDisapproved : null,
				dtError : null,
				dtArchived : null,
				dtDraft : null,
			};
		},
        mounted() {
			gThat = this;
			this.can('payments|create_payroll_batch').then(result => {
                this.payments = result.payments;
				this.create_payroll_batch = result.create_payroll_batch;
            }).then(result => {
                if(this.payments == true){
					this.dtNew = $('#dt-new').DataTable({
						processing: true,
						serverSide: true,
						searching: false,
						"sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
						ajax: {
							"url": "api/listNewEmployeePayments",
							"headers": window.axios.defaults.headers.common,
							"dataSrc": "records",
						},
						deferRender: true,
						columns: [
							{data: 'bid', visible: false},
							{render: function(data,type,full){
								var batch_name = full['sName'];
								if(batch_name == null || batch_name == ''){
									var to_return = 'N/A'
								}else {
									var to_return = batch_name
								}
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								// text-limit-10
								to_return = '<a class="text-limit " title="'+to_return+'" href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{render: function(data,type,full){
								var date = full['created'];
								return ''+moment(date).format('MMM D, Y')+'';
							}},
							{render: function(data,type,full){
								var pType = full['payroll_type'];
								if(pType == 'PAYROLL'){
									var to_return = 'Payroll';
								}else if(pType == 'DISBURSEMENT'){
									var to_return = 'Disbursement';
								}else if(pType == 'VENDOR'){
									var to_return = 'Vendor';
								}else{
									var status = full['sType'];
									if(status == 0){
										var to_return = 'Manual Entry'
									}else if(status == 1){
										var to_return = 'Payroll-Permanent'
									}else if(status == 2){
										var to_return = 'Payroll-Contractual'
									}else if(status == 3){
										var to_return = 'Commission'
									}else if(status == 4){
										var to_return = 'Reimbursement'
									}else if(status == 5){
										var to_return = 'Payroll Lite'
									}
								}
								var to_return = '';
								var pFreq = full['payroll_frequency'];
								if(pType == 'PAYROLL') {
									to_return = 'Employee';
									if (pFreq == 'ONETIME') {
										//
									}
								}else if(pType == 'PARTIAL_PAYROLL'){
									to_return = 'Partial Payroll'
								}else if(pType == 'COMMISSION'){
									to_return = 'Commission'
								}else if(pType == 'REIMBURSEMENT'){
									to_return = 'Reimbursement'
								}else{
									to_return = 'Vendor';
								}
								return to_return;
							}},
							{render: function(data,type,full){
								var payroll_type = full['payroll_type'];
								var payroll_frequency = full['payroll_frequency'];
								if(payroll_type == 'DISBURSEMENT' || payroll_frequency == 'ONETIME'){
									var date = full['onetime_date'];
									if(payroll_type == 'VENDOR'){
										date = full['created_at'];
									}
									return ''+moment(date).format('MMM D, Y')+'';
								}else{
									var date = moment(full['fromdate']).format('MMM D, Y')+' - '+moment(full['todate']).format('MMM D, Y');
									return '' + date + '';
								}
							}},
							{data: 'amount', render: $.fn.dataTable.render.number(',')},
							{render: function(data,type,full){
								var status = full['pStatus'];
                                    if (status == 1) {
                                        var to_return =
                                            '<span class="status uploaded">Uploaded </span>';
                                    } else if (status == 2) {
                                        var to_return =
                                            '<span class="status uploaded">Under Review </span>';
                                    } else if (status == 3) {
                                        var to_return = '<span class="status checked"> Checked </span>';
                                    } else if (status == 4) {
                                        var to_return = '<span class="status partial">Partial  </span>';
                                    } else if (status == 5) {
                                        var to_return =
                                            '<span class="status processing"> Processed </span>';
                                    } else if (status == 6) {
                                        var to_return =
                                            '<span class="status disapproved">Disapproved </span>';
                                    } else if (status == 7) {
                                        var to_return = '<span class="status flagged"> Flagged </span>';
                                    } else if (status == 8) {
                                        var to_return = '<span class="status">Archive  </span>';
                                    } else if (status == 10) {
                                        var to_return =
                                            '<span class="status processing"> In Process  </span>';
                                    } else if (status == 11) {
                                        var to_return =
                                            '<span class="status disapproved"> Error  </span>';
                                    }
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{data: 'bId', sorting: false, render: function(data,type,full){
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class=""> <span class="status processing"> Process </span> </a></td>';
							}}
						],
						"drawCallback": function() {
							$(".action").tooltip();
						},
                        "order": [[ 0, "desc" ]],
                        "initComplete": (settings, json) => { this.new_batch_count = json.recordsTotal; }
					});
					this.dtInprocess = $('#dt-inprocess').DataTable({
						processing: true,
						serverSide: true,
						searching: false,
						"sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
						ajax: {
							"url": "api/listInprocessEmployeePayments",
							"headers": window.axios.defaults.headers.common,
							"dataSrc": "records",
						},
						deferRender: true,
						columns: [
							{data: 'bid', visible: false},
							{render: function(data,type,full){
								var batch_name = full['sName'];
								if(batch_name == null || batch_name == ''){
									var to_return = 'N/A'
								}else {
									var to_return = batch_name
								}
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{render: function(data,type,full){
								var date = full['created'];
								return ''+moment(date).format('MMM D, Y')+'';
							}},
							{render: function(data,type,full){
								var pType = full['payroll_type'];
								if(pType == 'PAYROLL'){
									var to_return = 'Payroll';
								}else if(pType == 'DISBURSEMENT'){
									var to_return = 'Disbursement';
								}else if(pType == 'VENDOR'){
									var to_return = 'Vendor';
								}else{
									var status = full['sType'];
									if(status == 0){
										var to_return = 'Manual Entry'
									}else if(status == 1){
										var to_return = 'Payroll-Permanent'
									}else if(status == 2){
										var to_return = 'Payroll-Contractual'
									}else if(status == 3){
										var to_return = 'Commission'
									}else if(status == 4){
										var to_return = 'Reimbursement'
									}else if(status == 5){
										var to_return = 'Payroll Lite'
									}
								}
								var to_return = '';
								var pFreq = full['payroll_frequency'];
								if(pType == 'PAYROLL') {
									to_return = 'Employee';
									if (pFreq == 'ONETIME') {
										//
									}
								}else if(pType == 'PARTIAL_PAYROLL'){
									to_return = 'Partial Payroll'
								}else if(pType == 'COMMISSION'){
									to_return = 'Commission'
								}else if(pType == 'REIMBURSEMENT'){
									to_return = 'Reimbursement'
								}else{
									to_return = 'Vendor';
								}
								return to_return;
							}},
							{render: function(data,type,full){
								var payroll_type = full['payroll_type'];
								var payroll_frequency = full['payroll_frequency'];
								if(payroll_type == 'DISBURSEMENT' || payroll_frequency == 'ONETIME'){
									var date = full['onetime_date'];
									if(payroll_type == 'VENDOR'){
										date = full['created_at'];
									}
									return ''+moment(date).format('MMM D, Y')+'';
								}else{
									var date = moment(full['fromdate']).format('MMM D, Y')+' - '+moment(full['todate']).format('MMM D, Y');
									return '' + date + '';
								}
							}},
							{data: 'amount', render: $.fn.dataTable.render.number(',')},
							{render: function(data,type,full){
								var status = full['pStatus'];
								var actual_status = full["actual_status"];
								if(actual_status){
								var to_return =
									'<span class="status pending" style="border-color: #ffc107; color: #ffc107;">Pending </span>';
								}else if(status == 1){
									var to_return = '<span class="status uploaded"> Uploaded </span>'
								}else if(status == 2){
									var to_return = '<span class="status"> Under review </span>'
								}else if(status == 3){
									var to_return = '<span class="status checked"> Checked </span>'
								}else if(status == 4){
									var to_return = '<span class="status"> Partial </span>'
								}else if(status == 5){
									var to_return = '<span class="status processed"> Processed </span>'
								}else if(status == 6){
									var to_return = '<span class="status disapproved"> Disapproved </span>'
								}else if(status == 7){
									var to_return = '<span class="status flagged"> Flagged </span>'
								}else if(status == 8){
									var to_return = '<span class="status"> Archived </span>'
								}else if(status == 10){
									var to_return = '<span class="status processing"> Processing </span>'
								}else if(status == 11){
									var to_return = '<span class="status error"> Error </span>'
								}
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{data: 'id', sorting: false, render: function(data,type,full){
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';
							}},
						],
						"drawCallback": function() {
							$(".action").tooltip();
						},
                        "order": [[ 0, "desc" ]],
                        "initComplete": (settings, json) => { this.inprocess_batch_count = json.recordsTotal; }
					});
					this.dtprocessed = $('#dt-processed').DataTable({
						processing: true,
						serverSide: true,
						searching: false,
						"sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
						ajax: {
							"url": "api/listProcessedEmployeePayments",
							"headers": window.axios.defaults.headers.common,
							"dataSrc": "records",
						},
						deferRender: true,
						columns: [
							{data: 'bid', visible: false},
							{render: function(data,type,full){
								var batch_name = full['sName'];
								if(batch_name == null || batch_name == ''){
									var to_return = 'N/A'
								}else {
									var to_return = batch_name
								}
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{render: function(data,type,full){
								var date = full['created'];
								return ''+moment(date).format('MMM D, Y')+'';
							}},
							{render: function(data,type,full){
								var pType = full['payroll_type'];
								if(pType == 'PAYROLL'){
									var to_return = 'Payroll';
								}else if(pType == 'DISBURSEMENT'){
									var to_return = 'Disbursement';
								}else if(pType == 'VENDOR'){
									var to_return = 'Vendor';
								}else{
									var status = full['sType'];
									if(status == 0){
										var to_return = 'Manual Entry'
									}else if(status == 1){
										var to_return = 'Payroll-Permanent'
									}else if(status == 2){
										var to_return = 'Payroll-Contractual'
									}else if(status == 3){
										var to_return = 'Commission'
									}else if(status == 4){
										var to_return = 'Reimbursement'
									}else if(status == 5){
										var to_return = 'Payroll Lite'
									}
								}
								var to_return = '';
								var pFreq = full['payroll_frequency'];
								if(pType == 'PAYROLL') {
									to_return = 'Employee';
									if (pFreq == 'ONETIME') {
										//
									}
								}else if(pType == 'PARTIAL_PAYROLL'){
									to_return = 'Partial Payroll'
								}else if(pType == 'COMMISSION'){
									to_return = 'Commission'
								}else if(pType == 'REIMBURSEMENT'){
									to_return = 'Reimbursement'
								}else{
									to_return = 'Vendor';
								}
								return to_return;
							}},
							{render: function(data,type,full){
								var payroll_type = full['payroll_type'];
								var payroll_frequency = full['payroll_frequency'];
								if(payroll_type == 'DISBURSEMENT' || payroll_frequency == 'ONETIME'){
									var date = full['onetime_date'];
									if(payroll_type == 'VENDOR'){
										date = full['created_at'];
									}
									return ''+moment(date).format('MMM D, Y')+'';
								}else{
									var date = moment(full['fromdate']).format('MMM D, Y')+' - '+moment(full['todate']).format('MMM D, Y');
									return '' + date + '';
								}
							}},
							{data: 'amount', render: $.fn.dataTable.render.number(',')},
							{render: function(data,type,full){
								var status = full['pStatus'];
                                    if (status == 1) {
                                        var to_return =
                                            '<span class="status uploaded">Uploaded </span>';
                                    } else if (status == 2) {
                                        var to_return =
                                            '<span class="status uploaded">Under Review </span>';
                                    } else if (status == 3) {
                                        var to_return = '<span class="status checked"> Checked </span>';
                                    } else if (status == 4) {
                                        var to_return = '<span class="status partial">Partial  </span>';
                                    } else if (status == 5) {
                                        var to_return =
                                            '<span class="status processing"> Processed </span>';
                                    } else if (status == 6) {
                                        var to_return =
                                            '<span class="status disapproved">Disapproved </span>';
                                    } else if (status == 7) {
                                        var to_return = '<span class="status flagged"> Flagged </span>';
                                    } else if (status == 8) {
                                        var to_return = '<span class="status">Archive  </span>';
                                    } else if (status == 10) {
                                        var to_return =
                                            '<span class="status processing"> In Process  </span>';
                                    } else if (status == 11) {
                                        var to_return =
                                            '<span class="status disapproved"> Error  </span>';
                                    }
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{data: 'id', sorting: false, render: function(data,type,full){
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';
							}},
						],
						"drawCallback": function() {
							$(".action").tooltip();
						},
						"order": [[ 0, "desc" ]],
                        "initComplete": (settings, json) => { this.processed_batch_count = json.recordsTotal; }

                    });
					this.dtDisapproved = $('#dt-disapproved').DataTable({
						processing: true,
						serverSide: true,
						searching: false,
						"sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
						ajax: {
							"url": "api/listDisapprovedEmployeePayments",
							"headers": window.axios.defaults.headers.common,
							"dataSrc": "records",
						},
						deferRender: true,
						columns: [
							{data: 'bid', visible: false},
							{render: function(data,type,full){
								var batch_name = full['sName'];
								if(batch_name == null || batch_name == ''){
									var to_return = 'N/A'
								}else {
									var to_return = batch_name
								}
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{render: function(data,type,full){
								var date = full['created'];
								return ''+moment(date).format('MMM D, Y')+'';
							}},
							{render: function(data,type,full){
								var pType = full['payroll_type'];
								if(pType == 'PAYROLL'){
									var to_return = 'Payroll';
								}else if(pType == 'DISBURSEMENT'){
									var to_return = 'Disbursement';
								}else if(pType == 'VENDOR'){
									var to_return = 'Vendor';
								}else{
									var status = full['sType'];
									if(status == 0){
										var to_return = 'Manual Entry'
									}else if(status == 1){
										var to_return = 'Payroll-Permanent'
									}else if(status == 2){
										var to_return = 'Payroll-Contractual'
									}else if(status == 3){
										var to_return = 'Commission'
									}else if(status == 4){
										var to_return = 'Reimbursement'
									}else if(status == 5){
										var to_return = 'Payroll Lite'
									}
								}
								var to_return = '';
								var pFreq = full['payroll_frequency'];
								if(pType == 'PAYROLL') {
									to_return = 'Employee';
									if (pFreq == 'ONETIME') {
										//
									}
								}else if(pType == 'PARTIAL_PAYROLL'){
									to_return = 'Partial Payroll'
								}else if(pType == 'COMMISSION'){
									to_return = 'Commission'
								}else if(pType == 'REIMBURSEMENT'){
									to_return = 'Reimbursement'
								}else{
									to_return = 'Vendor';
								}
								return to_return;
							}},
							{render: function(data,type,full){
								var payroll_type = full['payroll_type'];
								var payroll_frequency = full['payroll_frequency'];
								if(payroll_type == 'DISBURSEMENT' || payroll_frequency == 'ONETIME'){
									var date = full['onetime_date'];
									if(payroll_type == 'VENDOR'){
										date = full['created_at'];
									}
									return ''+moment(date).format('MMM D, Y')+'';
								}else{
									var date = moment(full['fromdate']).format('MMM D, Y')+' - '+moment(full['todate']).format('MMM D, Y');
									return '' + date + '';
								}
							}},
							{data: 'amount', render: $.fn.dataTable.render.number(',')},
							{render: function(data,type,full){
								var status = full['pStatus'];
                                    if (status == 1) {
                                        var to_return =
                                            '<span class="status uploaded">Uploaded </span>';
                                    } else if (status == 2) {
                                        var to_return =
                                            '<span class="status uploaded">Under Review </span>';
                                    } else if (status == 3) {
                                        var to_return = '<span class="status checked"> Checked </span>';
                                    } else if (status == 4) {
                                        var to_return = '<span class="status partial">Partial  </span>';
                                    } else if (status == 5) {
                                        var to_return =
                                            '<span class="status processing"> Processed </span>';
                                    } else if (status == 6) {
                                        var to_return =
                                            '<span class="status disapproved">Disapproved </span>';
                                    } else if (status == 7) {
                                        var to_return = '<span class="status flagged"> Flagged </span>';
                                    } else if (status == 8) {
                                        var to_return = '<span class="status">Archive  </span>';
                                    } else if (status == 10) {
                                        var to_return =
                                            '<span class="status processing"> In Process  </span>';
                                    } else if (status == 11) {
                                        var to_return =
                                            '<span class="status disapproved"> Error  </span>';
                                    }
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{data: 'id', sorting: false, render: function(data,type,full){
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';
							}},
						],
						"drawCallback": function() {
							$(".action").tooltip();
						},
						"order": [[ 0, "desc" ]],
                        "initComplete": (settings, json) => { this.disapproved_batch_count = json.recordsTotal; }

                    });
					this.dtError = $('#dt-error').DataTable({
						processing: true,
						serverSide: true,
						searching: false,
						"sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
						ajax: {
							"url": "api/listErrorEmployeePayments",
							"headers": window.axios.defaults.headers.common,
							"dataSrc": "records",
						},
						deferRender: true,
						columns: [
							{data: 'bid', visible: false},
							{render: function(data,type,full){
								var batch_name = full['sName'];
								if(batch_name == null || batch_name == ''){
									var to_return = 'N/A'
								}else {
									var to_return = batch_name
								}
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{render: function(data,type,full){
								var date = full['created'];
								return ''+moment(date).format('MMM D, Y')+'';
							}},
							{render: function(data,type,full){
								var pType = full['payroll_type'];
								if(pType == 'PAYROLL'){
									var to_return = 'Payroll';
								}else if(pType == 'DISBURSEMENT'){
									var to_return = 'Disbursement';
								}else if(pType == 'VENDOR'){
									var to_return = 'Vendor';
								}else{
									var status = full['sType'];
									if(status == 0){
										var to_return = 'Manual Entry'
									}else if(status == 1){
										var to_return = 'Payroll-Permanent'
									}else if(status == 2){
										var to_return = 'Payroll-Contractual'
									}else if(status == 3){
										var to_return = 'Commission'
									}else if(status == 4){
										var to_return = 'Reimbursement'
									}else if(status == 5){
										var to_return = 'Payroll Lite'
									}
								}
								var to_return = '';
								var pFreq = full['payroll_frequency'];
								if(pType == 'PAYROLL') {
									to_return = 'Employee';
									if (pFreq == 'ONETIME') {
										//
									}
								}else if(pType == 'PARTIAL_PAYROLL'){
									to_return = 'Partial Payroll'
								}else if(pType == 'COMMISSION'){
									to_return = 'Commission'
								}else if(pType == 'REIMBURSEMENT'){
									to_return = 'Reimbursement'
								}else{
									to_return = 'Vendor';
								}
								return to_return;
							}},
							{render: function(data,type,full){
								var payroll_type = full['payroll_type'];
								var payroll_frequency = full['payroll_frequency'];
								if(payroll_type == 'DISBURSEMENT' || payroll_frequency == 'ONETIME'){
									var date = full['onetime_date'];
									if(payroll_type == 'VENDOR'){
										date = full['created_at'];
									}
									return ''+moment(date).format('MMM D, Y')+'';
								}else{
									var date = moment(full['fromdate']).format('MMM D, Y')+' - '+moment(full['todate']).format('MMM D, Y');
									return '' + date + '';
								}
							}},
							{data: 'amount', render: $.fn.dataTable.render.number(',')},
							{render: function(data,type,full){
								var status = full['pStatus'];
                                    if (status == 1) {
                                        var to_return =
                                            '<span class="status uploaded">Uploaded </span>';
                                    } else if (status == 2) {
                                        var to_return =
                                            '<span class="status uploaded">Under Review </span>';
                                    } else if (status == 3) {
                                        var to_return = '<span class="status checked"> Checked </span>';
                                    } else if (status == 4) {
                                        var to_return = '<span class="status partial">Partial  </span>';
                                    } else if (status == 5) {
                                        var to_return =
                                            '<span class="status processing"> Processed </span>';
                                    } else if (status == 6) {
                                        var to_return =
                                            '<span class="status disapproved">Disapproved </span>';
                                    } else if (status == 7) {
                                        var to_return = '<span class="status flagged"> Flagged </span>';
                                    } else if (status == 8) {
                                        var to_return = '<span class="status">Archive  </span>';
                                    } else if (status == 10) {
                                        var to_return =
                                            '<span class="status processing"> In Process  </span>';
                                    } else if (status == 11) {
                                        var to_return =
                                            '<span class="status disapproved"> Error  </span>';
                                    }
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{data: 'id', sorting: false, render: function(data,type,full){
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';
							}},
						],
						"drawCallback": function() {
							$(".action").tooltip();
						},
						"order": [[ 0, "desc" ]],
                        "initComplete": (settings, json) => { this.error_batch_count = json.recordsTotal; }

                    });
					this.dtArchived = $('#dt-archived').DataTable({
						processing: true,
						serverSide: true,
						searching: false,
						"sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
						ajax: {
							"url": "api/listArchivedEmployeePayments",
							"headers": window.axios.defaults.headers.common,
							"dataSrc": "records",
						},
						deferRender: true,
						columns: [
							{data: 'bid', visible: false},
							{render: function(data,type,full){
								var batch_name = full['sName'];
								if(batch_name == null || batch_name == ''){
									var to_return = 'N/A'
								}else {
									var to_return = batch_name
								}
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{render: function(data,type,full){
								var date = full['created'];
								return ''+moment(date).format('MMM D, Y')+'';
							}},
							{render: function(data,type,full){
								var pType = full['payroll_type'];
								if(pType == 'PAYROLL'){
									var to_return = 'Payroll';
								}else if(pType == 'DISBURSEMENT'){
									var to_return = 'Disbursement';
								}else if(pType == 'VENDOR'){
									var to_return = 'Vendor';
								}else{
									var status = full['sType'];
									if(status == 0){
										var to_return = 'Manual Entry'
									}else if(status == 1){
										var to_return = 'Payroll-Permanent'
									}else if(status == 2){
										var to_return = 'Payroll-Contractual'
									}else if(status == 3){
										var to_return = 'Commission'
									}else if(status == 4){
										var to_return = 'Reimbursement'
									}else if(status == 5){
										var to_return = 'Payroll Lite'
									}
								}
								var to_return = '';
								var pFreq = full['payroll_frequency'];
								if(pType == 'PAYROLL') {
									to_return = 'Employee';
									if (pFreq == 'ONETIME') {
										//
									}
								}else if(pType == 'PARTIAL_PAYROLL'){
									to_return = 'Partial Payroll'
								}else if(pType == 'COMMISSION'){
									to_return = 'Commission'
								}else if(pType == 'REIMBURSEMENT'){
									to_return = 'Reimbursement'
								}else{
									to_return = 'Vendor';
								}
								return to_return;
							}},
							{render: function(data,type,full){
								var payroll_type = full['payroll_type'];
								var payroll_frequency = full['payroll_frequency'];
								if(payroll_type == 'DISBURSEMENT' || payroll_frequency == 'ONETIME'){
									var date = full['onetime_date'];
									if(payroll_type == 'VENDOR'){
										date = full['created_at'];
									}
									return ''+moment(date).format('MMM D, Y')+'';
								}else{
									var date = moment(full['fromdate']).format('MMM D, Y')+' - '+moment(full['todate']).format('MMM D, Y');
									return '' + date + '';
								}
							}},
							{data: 'amount', render: $.fn.dataTable.render.number(',')},
							{render: function(data,type,full){
								var status = full['pStatus'];
                                    if (status == 1) {
                                        var to_return =
                                            '<span class="status uploaded">Uploaded </span>';
                                    } else if (status == 2) {
                                        var to_return =
                                            '<span class="status uploaded">Under Review </span>';
                                    } else if (status == 3) {
                                        var to_return = '<span class="status checked"> Checked </span>';
                                    } else if (status == 4) {
                                        var to_return = '<span class="status partial">Partial  </span>';
                                    } else if (status == 5) {
                                        var to_return =
                                            '<span class="status processing"> Processed </span>';
                                    } else if (status == 6) {
                                        var to_return =
                                            '<span class="status disapproved">Disapproved </span>';
                                    } else if (status == 7) {
                                        var to_return = '<span class="status flagged"> Flagged </span>';
                                    } else if (status == 8) {
                                        var to_return = '<span class="status">Archive  </span>';
                                    } else if (status == 10) {
                                        var to_return =
                                            '<span class="status processing"> In Process  </span>';
                                    } else if (status == 11) {
                                        var to_return =
                                            '<span class="status disapproved"> Error  </span>';
                                    }
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
								return to_return;
							}},
							{data: 'id', sorting: false, render: function(data,type,full){
								var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
								return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';
							}},
						],
						"drawCallback": function() {
							$(".action").tooltip();
						},
						"order": [[ 0, "desc" ]],
                        "initComplete": (settings, json) => { this.archived_batch_count = json.recordsTotal; }

					});

					if(this.create_payroll_batch == true){
						this.dtDraft = $('#dt-draft').DataTable({
							processing: true,
							serverSide: true,
							searching: false,
							"sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
							ajax: {
								"url": "api/listDraftEmployeePayments",
								"headers": window.axios.defaults.headers.common,
								"dataSrc": "records",
							},
							deferRender: true,
							columns: [
								{data: 'id', visible: false},
								{render: function(data,type,full){
									var batch_name = full['title'];
									if(batch_name == null || batch_name == ''){
										var date = full['created_at'];
										var to_return = ''+moment(date).format('MMM, Y')+''
									}else {
										var to_return = batch_name
									}
									if(full['state'] == 'START'){
										var $url = '/autoPaymentUsers/'+full['id'];
									}else if(full['state'] == 'TIMEOFF'){
										var $url = '/autoPaymentTimeOff/'+full['id'];
									}else if(full['state'] == 'EARNING'){
										var $url = '/autoPaymentEarnings/'+full['id'];
									}else if(full['state'] == 'SUBMIT'){
										var $url = '/autoPaymentReview/'+full['id'];
									}
									to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
									return to_return;
								}},
								{render: function(data,type,full){
									var date = full['created_at'];
									return ''+moment(date).format('MMM D, Y')+'';
								}},
								{render: function(data,type,full){
									var date = full['from_date'];
									return ''+moment(date).format('MMM, Y')+'';
								}},
								{data: 'net_amount', render: $.fn.dataTable.render.number(',')},
								{data: 'state'},
								{data: 'id', sorting: false, render: function(data,type,full){
									if(full['state'] == 'START'){
										var $url = '/autoPaymentUsers/'+full['id'];
									}else if(full['state'] == 'TIMEOFF'){
										var $url = '/autoPaymentTimeOff/'+full['id'];
									}else if(full['state'] == 'EARNING'){
										var $url = '/autoPaymentEarnings/'+full['id'];
									}else if(full['state'] == 'SUBMIT'){
										var $url = '/autoPaymentReview/'+full['id'];
									}
									return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';
								}},
							],
							"drawCallback": function() {
								$(".action").tooltip();
							},
							"order": [[ 0, "desc" ]],
                            "initComplete": (settings, json) => { this.draft_batch_count = json.recordsTotal; }

                        });
					}
                }else{
                    this.$Progress.finish();
                }
			});
        },
		methods: {
			proceedToAutoGenerate(){
				this.tick_active = true;
				setTimeout(() => {
					$('#newBatchModal').modal('hide');
					this.$router.push('/autoGeneratePayment');
				}, 1000);
			},
            proceedToGenerateBatch(){
                this.tick_active = true;
                setTimeout(() => {
                    $('#newBatchModal').modal('hide');
                    this.$router.push('/generatePaymentBatch');
                }, 1000);
			},
			reloadList(tabClicked){

				switch(tabClicked)
				{
					case 'new':
						if(gThat.currentActiveTab !== 'new')
						{
							gThat.isDataTableLoading = true;

							gThat.dtNew.ajax.reload(function(json){
								gThat.new_batch_count 	= json.recordsTotal;
								gThat.isDataTableLoading 	= false;
							}, false);

							gThat.currentActiveTab = 'new';	
						}
					break;

					case 'inprocess':
						if(gThat.currentActiveTab !== 'inprocess')
						{
							gThat.isDataTableLoading = true;

							gThat.dtInprocess.ajax.reload(function(json){
								gThat.inprocess_batch_count 	= json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'inprocess';
						}
					break;

					case 'processed':
						if(gThat.currentActiveTab !== 'processed')
						{
							gThat.isDataTableLoading = true;

							gThat.dtprocessed.ajax.reload(function(json){
								gThat.processed_batch_count 	= json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'processed';
						}
					break;

					case 'disapproved':
						if(gThat.currentActiveTab !== 'disapproved')
						{
							gThat.isDataTableLoading = true;

							gThat.dtDisapproved.ajax.reload(function(json){
								gThat.disapproved_batch_count = json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'disapproved';
						}
					break;

					case 'error':
						if(gThat.currentActiveTab !== 'error')
						{
							gThat.isDataTableLoading = true;

							gThat.dtError.ajax.reload(function(json){
								gThat.error_batch_count 		= json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'error';
						}
					break;

					case 'archived':
						if(gThat.currentActiveTab !== 'archived')
						{
							gThat.isDataTableLoading = true;

							gThat.dtArchived.ajax.reload(function(json){
								gThat.archived_batch_count = json.recordsTotal;
								gThat.isDataTableLoading 	 = false;
							}, false);

							gThat.currentActiveTab = 'archived';
						}
					break;

					case 'draft':
						if(gThat.currentActiveTab !== 'draft')
						{
							gThat.isDataTableLoading = true;

							gThat.dtDraft.ajax.reload(function(json){
								gThat.draft_batch_count 	= json.recordsTotal;
								gThat.isDataTableLoading 	= false;
							}, false);

							gThat.currentActiveTab = 'draft';
						}
					break;
				}
			}
		}
    }
</script>
